<template>
    <toolbar-option>
        <template slot="primary">
            <div class="f-flex f-justify-between f-items-center f-mt-0.25 f-mb-1">
                <div class="f-w-5/10">
                    <calendar-facet-day-color
                        :value="day.color"
                        @input="onColorInput"
                    />
                </div>
                <div class="f-w-5/10">
                    <calendar-facet-day-disabled-color
                        :value="day.disabledColor"
                        @input="onDisabledColorInput"
                    />
                </div>
            </div>
            <calendar-facet-day-font-family
                :value="day.font"
                @input="onFontInput"
            />
            <calendar-facet-day-font-size
                :value="day.size"
                @input="onFontSizeInput"
            />
            <calendar-facet-day-font-style
                :value="day.style"
                @input="onFontStyleInput"
            />
            <calendar-facet-day-font-weight
                :value="day.weight"
                @input="onFontWeightInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'calendar-facet-day';

export default {
    name: 'calendar-facet-day',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Day Options',
            message: '',
            value: '',
            checked: false,
            day: {
                color: '',
                font: '',
                weight: '',
                size: 'vc-font-medium',
                style: '',
                disabledColor: 'vc-text-gray-400',
            },
        };
    },

    methods: {
        onColorInput(cssClass) {
            this.day.color = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.day);
            this.selectedElements[0].dayFontColorClass = cssClass;
        },

        onDisabledColorInput(cssClass) {
            this.day.disabledColor = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.day);
            this.selectedElements[0].dayFontDisabledColor = cssClass;
        },

        onFontInput(cssClass) {
            this.day.font = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.day);
            this.selectedElements[0].dayFontClass = cssClass;
        },

        onFontSizeInput(cssClass) {
            this.day.size = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.day);
            this.selectedElements[0].dayFontSizeClass = cssClass;
        },

        onFontStyleInput(cssClass) {
            this.day.style = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.day);
            this.selectedElements[0].dayFontStyleClass = cssClass;
        },

        onFontWeightInput(cssClass) {
            this.day.weight = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.day);
            this.selectedElements[0].dayFontWeightClass = cssClass;
        },

        onSelectedElement() {
            this.day = this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME) ? this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME) : this.day;
        },
    },
};
</script>
